// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_confirmation-finish-process {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 24px;
  min-height: calc(92vh - 120px);
}
.container_confirmation-finish-process h3 {
  color: #00254A;
  text-align: center;
  font-family: Roboto;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.container_confirmation-finish-process p {
  color: #00254A;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.container_confirmation-finish-process p b {
  color: #00254A;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/finish-process/style.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;AACH;AAAC;EACE,cAAA;EACC,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AAAC;EACG,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AADE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAGJ","sourcesContent":[".container_confirmation-finish-process {\n   display: flex;\n   flex-direction: column;\n   gap: 16px;\n   align-items: center;  \n   width: 100%; \n   padding-left: 16px;\n   padding-right: 16px;\n   padding-top: 24px;\n   min-height: calc(92vh - 120px);\n h3 {\n   color: #00254A;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n }\n p {\n    color: #00254A;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  b {\n    color: #00254A;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 150% */\n  }\n }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
